import config from "../config/config";

let AdminSocket;
let clientSocket;
let workerSocket;

export const connectAdminSocket = (setAdminUser) => {
  AdminSocket = new WebSocket(config.ADMIN_USER_SOCKET_URL);

  AdminSocket.onopen = () => {
    console.log("Connected to Admin WebSocket server successfully");
  };

  AdminSocket.onclose = () => {
    console.log("Disconnected from Admin WebSocket server");
  };

  AdminSocket.onerror = (error) => {
    console.error("Admin WebSocket error:", error);
  };

  AdminSocket.onmessage = (event) => {
    try {
      const adminUser = JSON.parse(event.data);
      if (adminUser && adminUser.assignedRole === "User Admin") {
        setAdminUser(adminUser);
        console.log("Admin user data updated from WebSocket:", adminUser);
      } 
    } catch (error) {
      console.error("Failed to parse admin WebSocket message:", error);
    }
  };
};

export const connectClientSocket = (setUser) => {
  clientSocket = new WebSocket(config.CLIENT_USER_SOCKET_URL);

  clientSocket.onopen = () => {
    console.log("Connected to client WebSocket server successfully");
  };

  clientSocket.onclose = () => {
    console.log("Disconnected from client WebSocket server");
  };

  clientSocket.onerror = (error) => {
    console.error("Client WebSocket error:", error);
  };

  clientSocket.onmessage = (event) => {
    try {
      const user = JSON.parse(event.data);
      if (user && user.userType === "client") {
        setUser(user);
        console.log("Client user data updated from WebSocket:", user);
      } else {
        console.error("Received invalid client user data:", event.data);
      }
    } catch (error) {
      console.error("Failed to parse client WebSocket message:", error);
    }
  };
};

export const connectWorkerSocket = (setUser) => {
  workerSocket = new WebSocket(config.WORKER_USER_SOCKET_URL);

  workerSocket.onopen = () => {
    console.log("Connected to worker WebSocket server successfully");
  };

  workerSocket.onclose = () => {
    console.log("Disconnected from worker WebSocket server");
  };

  workerSocket.onerror = (error) => {
    console.error("Worker WebSocket error:", error);
  };

  workerSocket.onmessage = (event) => {
    try {
      const user = JSON.parse(event.data);
      if (user && user.userType === "worker") {
        setUser(user);
        console.log("Worker user data updated from WebSocket:", user);
      } else {
        console.error("Received invalid worker user data:", event.data);
      }
    } catch (error) {
      console.error("Failed to parse worker WebSocket message:", error);
    }
  };
};

export const disconnectAdminSocket = () => {
  if (AdminSocket) {
    AdminSocket.close();
  }
};

export const disconnectClientSocket = () => {
  if (clientSocket) {
    clientSocket.close();
  }
};

export const disconnectWorkerSocket = () => {
  if (workerSocket) {
    workerSocket.close();
  }
};
